module.exports = "https://cdn-social.hiplatform.com/images/c9cff7cc769d23203b860d69fc0b7d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/woman.png
// module id = qclp
// module chunks = 0